module.exports = __webpack_public_path__ + "media/images/icons/gray-logo-14da70f7ed5acd3bda8d326ed80372b5.svg";